import { gql, useQuery } from '@apollo/client';

export interface IBankAccount {
    id: string,
    name: string,
    note: string,
    proj: string, // "afe61914-f69c-11eb-8ac0-00155d000c0a",
    account: string, //"UA053003350000000260072380180",
    bank_mfo: string, //"300335",
    bank_name: string, //"АТ \"РАЙФФАЙЗЕН БАНК\", м.Київ"
}

export interface IOrg {
  ref: string;
  name: string;
  bank_accounts: Array<IBankAccount>
  edrpou: string,
  contract_easypay?: {
    number: string,
    date: string
  }
}

const gQuery = gql(`query getUseOrgs($ref: String) {
      getOrgs(ref: $ref) {
        ref name edrpou bank_accounts contract_easypay {number date}
      }}`);


export const useOrgs = (ref?:string) => {

  const { data } = useQuery(gQuery, { variables: { ref: ref ?? null }, fetchPolicy: 'cache-first' });
  return {
    orgs: (data?.getOrgs ?? []) as IOrg[]
  };
};

